import React, { useEffect } from "react";
import { Stepper } from "react-form-stepper";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getOrderDetails } from "../../redux/features/order/orderSlice";
import OrderItemsCard from "./OrderItemsCard";
import { BiChevronLeft } from "react-icons/bi";
import Spinner from "../../components/Spinner";
const OrderDetails = () => {
  const { order, isLoading } = useSelector((state) => state.orders);

  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrderDetails(id));
  }, []);
  return (
    <>
      {isLoading ? (
        <div className=" min-h-screen ">
          <Spinner />
        </div>
      ) : (
        <>
          {order === null ? (
            <div>order not found</div>
          ) : (
            <div className=" min-h-screen px-[10px] md:px-[20px] lg:px-[3%] pt-3 ">
              <Link className=" lg:hidden" to="/profile">
                <span className="border border-slate-600 px-2 uppercase  ">
                  <BiChevronLeft className=" inline-block text-xl " /> back
                </span>
              </Link>
              <h1 className="font-bold text-2xl text-slate-700">
                Order Details
              </h1>
              <div className=" bg-white shadow p-2 rounded mt-5">
                <h1 className=" text-lg font-bold text-slate-900">
                  Order Status:
                </h1>
                <Stepper
                  steps={[
                    { label: "Pending" },
                    { label: "Accept" },
                    { label: "Preparing" },
                    { label: "way" },
                    { label: "Delivered" },
                  ]}
                  activeStep={0}
                />
              </div>

              <div className="bg-white shadow p-2 rounded mt-3">
                <h1 className=" text-lg font-bold text-slate-900 mb-2">
                  Additiona Info:
                </h1>
                <ul>
                  <li className=" border-b">
                    Order Id:
                    <span className=" font-semibold "> {order._id}</span>
                  </li>
                  <li className=" border-b">
                    Amount:
                    <span className=" font-semibold "> {order.amount}</span>
                  </li>
                  <li className=" border-b">
                    Qunatity:
                    <span className=" font-semibold "> {order.qunaity}</span>
                  </li>
                  <li className=" border-b">
                    Revciever:
                    <span className=" font-semibold "> {order.email}</span>
                  </li>
                  <li className=" border-b">
                    Ordered At:
                    <span className=" font-semibold ">
                      {" "}
                      {new Date(order.createdAt).toLocaleString()}
                    </span>
                  </li>
                </ul>
              </div>
              <div className="bg-white shadow p-2 rounded mt-3 ">
                <div className=" flex flex-row flex-wrap items-center ">
                  {order?.items?.map((item) => (
                    <OrderItemsCard
                      image={item.image}
                      name={item.name}
                      price={item.price}
                      description={item.description}
                      quantity={item.quantity}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default OrderDetails;
